import SystemInitialisationImpl from './system-initialisation.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Component for displaying system initialisation message.
 *
 * @class SystemInitialisation
 *
 * @memberof Mojito.Applications.Sports
 */

export default UIView('SystemInitialisation', SystemInitialisationImpl);
